import styled from 'styled-components'

export const StyledListElem = styled.li`
    padding: 0.25rem 1rem;
    text-decoration: none;
    color: #F4E8C1;
`

export const StyledList = styled.ul`
    display: flex;
    justify-content: space-around;
    align-items: center;
    list-style: none; 
    width: 100%;   
`;

